import React from 'react';
import PropTypes from 'prop-types';
// Material UI
import MuiSvgIcon from '@material-ui/core/SvgIcon';
// mdi
import {
  mdiAccount,
  mdiAccountOutline,
  mdiAccountArrowRight,
  mdiAccountBoxOutline,
  mdiAccountCog,
  mdiAccountGroupOutline,
  mdiAccountMinus,
  mdiAccountMultiple,
  mdiAccountRemove,
  mdiAccountPlus,
  mdiAlert,
  mdiAlertCircle,
  mdiAlertCircleOutline,
  mdiAlertOutline,
  mdiAnimationPlayOutline,
  mdiAntenna,
  mdiArrowDown,
  mdiArrowExpandAll,
  mdiArrowLeft,
  mdiArrowRightBold,
  mdiArrowRightCircleOutline,
  mdiAxisArrow,
  mdiAxisXArrowLock,
  mdiBackupRestore,
  mdiBell,
  mdiBellRing,
  mdiBoomGateUp,
  mdiBoomGateUpOutline,
  mdiBoomGateDownOutline,
  mdiBug,
  mdiCalendar,
  mdiCalendarArrowRight,
  mdiCalendarBlankMultiple,
  mdiCalendarCheck,
  mdiCalendarCheckOutline,
  mdiCalendarClock,
  mdiCalendarBlankOutline,
  mdiCalendarCursor,
  mdiCalendarEdit,
  mdiCalendarEnd,
  mdiCalendarPlus,
  mdiCalendarQuestion,
  mdiCalendarRange,
  mdiCalendarRefresh,
  mdiCalendarRemoveOutline,
  mdiCalendarStart,
  mdiCalendarText,
  mdiCalendarTextOutline,
  mdiCalendarToday,
  mdiCancel,
  mdiCar,
  mdiCardAccountDetailsStarOutline,
  mdiCardTextOutline,
  mdiCarInfo,
  mdiCarMultiple,
  mdiCarSide,
  mdiCast,
  mdiCastConnected,
  mdiCctv,
  mdiChartBar,
  mdiChartBarStacked,
  mdiChartLine,
  mdiCheck,
  mdiCheckCircle,
  mdiCheckCircleOutline,
  mdiCheckboxBlankOutline,
  mdiCheckboxIntermediate,
  mdiCheckboxMarkedCircleOutline,
  mdiCheckboxMarkedOutline,
  mdiCheckNetwork,
  mdiChevronDown,
  mdiChevronLeft,
  mdiChevronRight,
  mdiChevronUp,
  mdiCircleEditOutline,
  mdiCityVariant,
  mdiClipboardListOutline,
  mdiClipboardRemoveOutline,
  mdiClockEnd,
  mdiClockOutline,
  mdiClose,
  mdiCloseCircle,
  mdiCloseCircleOutline,
  mdiCloudAlert,
  mdiCloudCheck,
  mdiCloudCheckOutline,
  mdiCloudOffOutline,
  mdiCloudSync,
  mdiCodeTags,
  mdiCog,
  mdiCogBox,
  mdiCogOutline,
  mdiCogTransferOutline,
  mdiCollapseAll,
  mdiContentDuplicate,
  mdiContentSave,
  mdiCreditCard,
  mdiCreditCardCheck,
  mdiCreditCardOutline,
  mdiCreditCardRefundOutline,
  mdiCreditCardSettingsOutline,
  mdiCurrencyEur,
  mdiCurrencyEurOff,
  mdiDatabaseCheckOutline,
  mdiDelete,
  mdiDeleteCircleOutline,
  mdiDeleteSweep,
  mdiDeveloperBoard,
  mdiDialpad,
  mdiDomain,
  mdiDomainPlus,
  mdiDomainOff,
  mdiDotsVertical,
  mdiDownload,
  mdiElectricSwitch,
  mdiElectricSwitchClosed,
  mdiEmail,
  mdiEmailOutline,
  mdiEmailSendOutline,
  mdiExitToApp,
  mdiExpandAll,
  mdiEye,
  mdiEyeOff,
  mdiFile,
  mdiFileChart,
  mdiFileCheck,
  mdiFileDocumentOutline,
  mdiFileDownload,
  mdiFileExport,
  mdiFilePercent,
  mdiFilePdf,
  mdiFileTableOutline,
  mdiFileUpload,
  mdiFilter,
  mdiFilterRemoveOutline,
  mdiFilterVariantMinus,
  mdiFilterVariantPlus,
  mdiFilterVariantRemove,
  mdiFinance,
  mdiFormatLineSpacing,
  mdiFormatListBulletedType,
  mdiHelpCircleOutline,
  mdiHelpNetwork,
  mdiHexagonMultiple,
  mdiHexagonMultipleOutline,
  mdiHistory,
  mdiHome,
  mdiHomeCityOutline,
  mdiInformation,
  mdiInformationOutline,
  mdiInformationVariant,
  mdiIpNetwork,
  mdiKey,
  mdiKeyPlus,
  mdiKeyStar,
  mdiLink,
  mdiLinkBoxOutline,
  mdiLinkOff,
  mdiLinkVariant,
  mdiLocationEnter,
  mdiLocationExit,
  mdiLock,
  mdiLockOpenOutline,
  mdiLogin,
  mdiLoginVariant,
  mdiLogout,
  mdiLogoutVariant,
  mdiMagnify,
  mdiMapMarker,
  mdiMapMarkerOutline,
  mdiMemory,
  mdiMenu,
  mdiMenuDown,
  mdiMenuLeft,
  mdiMenuRight,
  mdiMessageTextOutline,
  mdiMinusCircle,
  mdiMinusCircleOutline,
  mdiMonitorCellphoneStar,
  mdiMonitorDashboard,
  mdiNetworkOutline,
  mdiNetworkStrength1,
  mdiNetworkStrength1Alert,
  mdiNetworkStrength2,
  mdiNetworkStrength3,
  mdiNetworkStrength4,
  mdiNetworkStrengthOutline,
  mdiNetworkStrengthOffOutline,
  mdiNumeric0Circle,
  mdiNumeric1Circle,
  mdiNumeric2BoxMultipleOutline,
  mdiNumeric3BoxMultipleOutline,
  mdiNumeric4BoxMultipleOutline,
  mdiNumeric5BoxMultipleOutline,
  mdiNumeric6BoxMultipleOutline,
  mdiNumeric7BoxMultipleOutline,
  mdiNumeric8BoxMultipleOutline,
  mdiNumeric9BoxMultipleOutline,
  mdiNumeric9PlusBoxMultipleOutline,
  mdiOpenInNew,
  mdiPackageDown,
  mdiPageFirst,
  mdiPageLast,
  mdiParking,
  mdiPauseCircleOutline,
  mdiPencil,
  mdiPhone,
  mdiPhoneOutline,
  mdiPlayCircleOutline,
  mdiPlaylistPlus,
  mdiPlaySpeed,
  mdiPlus,
  mdiPlusCircle,
  mdiPlusCircleOutline,
  mdiPound,
  mdiPower,
  mdiPowerStandby,
  mdiProgressCheck,
  mdiProgressClock,
  mdiProgressUpload,
  mdiRadioboxBlank,
  mdiRadioboxMarked,
  mdiRecord,
  mdiRefresh,
  mdiRestore,
  mdiSale,
  mdiSelectAll,
  mdiServerNetwork,
  mdiShape,
  mdiShuffle,
  mdiSignal2g,
  mdiSignal3g,
  mdiSignal4g,
  mdiSim,
  mdiStepForward,
  mdiStop,
  mdiStopCircle,
  mdiSubdirectoryArrowRight,
  mdiSwapHorizontal,
  mdiSync,
  mdiTable,
  mdiTableArrowRight,
  mdiTextBox,
  mdiTextBoxMultipleOutline,
  mdiTimerSand,
  mdiTimetable,
  mdiTrendingDown,
  mdiTrendingUp,
  mdiUpdate,
  mdiUpload,
  mdiViewGridOutline,
  mdiWalk,
  mdiWebClock,
  mdiBank,
  mdiBankTransfer,
  mdiWarehouse,
  mdiWhatsapp,
} from '@mdi/js';
// Additional icons provided here waiting for @mdi/js to be updated
import { OneparkLogoImg } from 'components/img/AssetImg';
import {
  mdiCalendarAlertOutline,
  mdiCalendarBadgeOutline,
  mdiCalendarEndOutline,
} from 'assets/images/icons/icons';
// Color
import { iconPalette } from './colors';
// Internal
import { getMuiColor } from './internal/Tools';

// Base icon
const BaseSvgIcon = React.memo(({
  iconPath, primary, secondary, color, defaultColor, ...otherProps
}) => {
  // Build icon props
  const iconProps = {
    color: getMuiColor(primary, secondary, null, 'inherit'),
    htmlColor: !(primary || secondary) ? (color || (defaultColor ? iconPalette.base : null)) : null,
  };

  return (
    <MuiSvgIcon {...iconProps} {...otherProps}>
      <path d={iconPath} />
    </MuiSvgIcon>
  );
});

BaseSvgIcon.displayName = 'BaseSvgIcon';

BaseSvgIcon.propTypes = {
  iconPath: PropTypes.string.isRequired,
  primary: PropTypes.bool,
  secondary: PropTypes.bool,
  color: PropTypes.string,
  defaultColor: PropTypes.bool,
};

BaseSvgIcon.defaultProps = {
  primary: false,
  secondary: false,
  color: null,
  defaultColor: false,
};

// SVG icons library
/* eslint-disable react/display-name */
const SvgIcons = {
  // Buttons
  btnOneparkLogo: () => OneparkLogoImg(null, 20),
  btnAccessRights: (props) => <BaseSvgIcon iconPath={mdiKeyStar} {...props} />,
  btnAccesses: (props) => <BaseSvgIcon iconPath={mdiTimetable} {...props} />,
  btnAccessWays: (props) => <BaseSvgIcon iconPath={mdiExitToApp} {...props} />,
  btnAccount: (props) => <BaseSvgIcon iconPath={mdiAccount} {...props} />,
  btnActivityReports: (props) => <BaseSvgIcon iconPath={mdiFileChart} {...props} />,
  btnAdd: (props) => <BaseSvgIcon iconPath={mdiPlus} {...props} />,
  btnAddAlt: (props) => <BaseSvgIcon iconPath={mdiPlusCircleOutline} {...props} />,
  btnAddCarpark: (props) => <BaseSvgIcon iconPath={mdiDomainPlus} {...props} />,
  btnAddCircle: (props) => <BaseSvgIcon iconPath={mdiPlusCircle} {...props} />,
  btnAddCustomer: (props) => <BaseSvgIcon iconPath={mdiAccountPlus} {...props} />,
  btnAddRight: (props) => <BaseSvgIcon iconPath={mdiKeyPlus} {...props} />,
  btnAddPlanning: (props) => <BaseSvgIcon iconPath={mdiCalendarPlus} {...props} />,
  btnAddTo: (props) => <BaseSvgIcon iconPath={mdiPlaylistPlus} {...props} />,
  btnAntipassback: (props) => <BaseSvgIcon iconPath={mdiAxisXArrowLock} {...props} />,
  btnAssignCustomer: (props) => <BaseSvgIcon iconPath={mdiAccountPlus} {...props} />,
  btnBack: (props) => <BaseSvgIcon iconPath={mdiArrowLeft} {...props} />,
  btnCancel: (props) => <BaseSvgIcon iconPath={mdiCloseCircle} {...props} />,
  btnCancelOutline: (props) => <BaseSvgIcon iconPath={mdiCloseCircleOutline} {...props} />,
  btnCapacity: (props) => <BaseSvgIcon iconPath={mdiFormatLineSpacing} {...props} />,
  btnCategorize: (props) => <BaseSvgIcon iconPath={mdiAccountArrowRight} {...props} />,
  btnChoose: (props) => <BaseSvgIcon iconPath={mdiCheckboxMarkedCircleOutline} {...props} />,
  btnConfiguration: (props) => <BaseSvgIcon iconPath={mdiViewGridOutline} {...props} />,
  btnBarChart: (props) => <BaseSvgIcon iconPath={mdiChartBar} {...props} />,
  btnBarChartStacked: (props) => <BaseSvgIcon iconPath={mdiChartBarStacked} {...props} />,
  btnBookings: (props) => <BaseSvgIcon iconPath={mdiCalendar} {...props} />,
  btnCalendarCheck: (props) => <BaseSvgIcon iconPath={mdiCalendarCheck} {...props} />,
  btnCalendarArrowRight: (props) => <BaseSvgIcon iconPath={mdiCalendarArrowRight} {...props} />,
  btnCheckout: (props) => <BaseSvgIcon iconPath={mdiLogoutVariant} {...props} />,
  btnChevronDown: (props) => <BaseSvgIcon iconPath={mdiChevronDown} {...props} />,
  btnChevronLeft: (props) => <BaseSvgIcon iconPath={mdiChevronLeft} {...props} />,
  btnChevronRight: (props) => <BaseSvgIcon iconPath={mdiChevronRight} {...props} />,
  btnChevronUp: (props) => <BaseSvgIcon iconPath={mdiChevronUp} {...props} />,
  btnClearFilters: (props) => <BaseSvgIcon iconPath={mdiFilterRemoveOutline} {...props} />,
  btnClose: (props) => <BaseSvgIcon iconPath={mdiClose} {...props} />,
  btnCloseDoor: (props) => <BaseSvgIcon iconPath={mdiBoomGateDownOutline} {...props} />,
  btnCollapse: (props) => <BaseSvgIcon iconPath={mdiCollapseAll} {...props} />,
  btnCreditCard: (props) => <BaseSvgIcon iconPath={mdiCreditCard} {...props} />,
  btnDailyCodes: (props) => <BaseSvgIcon iconPath={mdiDialpad} {...props} />,
  btnDashboard: (props) => <BaseSvgIcon iconPath={mdiMonitorDashboard} {...props} />,
  btnDeclareInside: (props) => <BaseSvgIcon iconPath={mdiLocationEnter} {...props} />,
  btnDeclareOutside: (props) => <BaseSvgIcon iconPath={mdiLocationExit} {...props} />,
  btnDelete: (props) => <BaseSvgIcon iconPath={mdiDelete} {...props} />,
  btnDeleteAll: (props) => <BaseSvgIcon iconPath={mdiDeleteSweep} {...props} />,
  btnDeleteAlt: (props) => <BaseSvgIcon iconPath={mdiDeleteCircleOutline} {...props} />,
  btnDeleteCustomer: (props) => <BaseSvgIcon iconPath={mdiAccountRemove} {...props} />,
  btnDevice: (props) => <BaseSvgIcon iconPath={mdiDeveloperBoard} {...props} />,
  btnDisable: (props) => <BaseSvgIcon iconPath={mdiCancel} {...props} />,
  btnDisplay: (props) => <BaseSvgIcon iconPath={mdiEye} {...props} />,
  btnDisplayList: (props) => <BaseSvgIcon iconPath={mdiTableArrowRight} {...props} />,
  btnDownload: (props) => <BaseSvgIcon iconPath={mdiDownload} {...props} />,
  btnDownloadArchive: (props) => <BaseSvgIcon iconPath={mdiPackageDown} {...props} />,
  btnDownloadFile: (props) => <BaseSvgIcon iconPath={mdiFileDownload} {...props} />,
  btnDuplicate: (props) => <BaseSvgIcon iconPath={mdiContentDuplicate} {...props} />,
  btnEdit: (props) => <BaseSvgIcon iconPath={mdiPencil} {...props} />,
  btnEditAlt: (props) => <BaseSvgIcon iconPath={mdiCircleEditOutline} {...props} />,
  btnEmail: (props) => <BaseSvgIcon iconPath={mdiEmail} {...props} />,
  btnEmailToSend: (props) => <BaseSvgIcon iconPath={mdiEmailSendOutline} {...props} />,
  btnEmptyCalendar: (props) => <BaseSvgIcon iconPath={mdiCalendarRemoveOutline} {...props} />,
  btnEnable: (props) => <BaseSvgIcon iconPath={mdiCheckCircleOutline} {...props} />,
  btnEquipment: (props) => <BaseSvgIcon iconPath={mdiDeveloperBoard} {...props} />,
  btnExpand: (props) => <BaseSvgIcon iconPath={mdiExpandAll} {...props} />,
  btnExport: (props) => <BaseSvgIcon iconPath={mdiFileExport} {...props} />,
  btnFiltersLess: (props) => <BaseSvgIcon iconPath={mdiFilterVariantMinus} {...props} />,
  btnFiltersMore: (props) => <BaseSvgIcon iconPath={mdiFilterVariantPlus} {...props} />,
  btnFiltersRemove: (props) => <BaseSvgIcon iconPath={mdiFilterVariantRemove} {...props} />,
  btnFinance: (props) => <BaseSvgIcon iconPath={mdiFinance} {...props} />,
  btnFinancialReports: (props) => <BaseSvgIcon iconPath={mdiFilePercent} {...props} />,
  btnFirstPage: (props) => <BaseSvgIcon iconPath={mdiPageFirst} {...props} />,
  btnInvoice: (props) => <BaseSvgIcon iconPath={mdiTextBoxMultipleOutline} {...props} />,
  btnGet: (props) => <BaseSvgIcon iconPath={mdiDownload} {...props} />,
  btnGroups: (props) => <BaseSvgIcon iconPath={mdiHexagonMultiple} {...props} />,
  btnHelp: (props) => <BaseSvgIcon iconPath={mdiHelpCircleOutline} {...props} />,
  btnHide: (props) => <BaseSvgIcon iconPath={mdiEyeOff} {...props} />,
  btnHistory: (props) => <BaseSvgIcon iconPath={mdiHistory} {...props} />,
  btnHome: (props) => <BaseSvgIcon iconPath={mdiHome} {...props} />,
  btnInfo: (props) => <BaseSvgIcon iconPath={mdiInformationOutline} {...props} />,
  btnInstallationInstructions: (props) => <BaseSvgIcon iconPath={mdiFilePdf} {...props} />,
  btnLastPage: (props) => <BaseSvgIcon iconPath={mdiPageLast} {...props} />,
  btnLineChart: (props) => <BaseSvgIcon iconPath={mdiChartLine} {...props} />,
  btnLink: (props) => <BaseSvgIcon iconPath={mdiLinkVariant} {...props} />,
  btnLogout: (props) => <BaseSvgIcon iconPath={mdiLogoutVariant} {...props} />,
  btnLogs: (props) => <BaseSvgIcon iconPath={mdiFileDocumentOutline} {...props} />,
  btnManage: (props) => <BaseSvgIcon iconPath={mdiCog} {...props} />,
  btnMapMarker: (props) => <BaseSvgIcon iconPath={mdiMapMarker} {...props} />,
  btnMenu: (props) => <BaseSvgIcon iconPath={mdiMenu} {...props} />,
  btnMenuDown: (props) => <BaseSvgIcon iconPath={mdiMenuDown} {...props} />,
  btnMenuLeft: (props) => <BaseSvgIcon iconPath={mdiMenuLeft} {...props} />,
  btnMenuRight: (props) => <BaseSvgIcon iconPath={mdiMenuRight} {...props} />,
  btnMinus: (props) => <BaseSvgIcon iconPath={mdiMinusCircleOutline} {...props} />,
  btnMoreVert: (props) => <BaseSvgIcon iconPath={mdiDotsVertical} {...props} />,
  btnNextPage: (props) => <BaseSvgIcon iconPath={mdiChevronRight} {...props} />,
  btnNotifications: (props) => <BaseSvgIcon iconPath={mdiBell} {...props} />,
  btnNotificationsTest: (props) => <BaseSvgIcon iconPath={mdiBellRing} {...props} />,
  btnOccupancy: (props) => <BaseSvgIcon iconPath={mdiLocationEnter} {...props} />,
  btnOnDemand: (props) => <BaseSvgIcon iconPath={mdiLoginVariant} {...props} />,
  btnOpenDoor: (props) => <BaseSvgIcon iconPath={mdiBoomGateUpOutline} {...props} />,
  btnOpenInNew: (props) => <BaseSvgIcon iconPath={mdiOpenInNew} {...props} />,
  btnOperation: (props) => <BaseSvgIcon iconPath={mdiAccountCog} {...props} />,
  btnParking: (props) => <BaseSvgIcon iconPath={mdiParking} {...props} />,
  btnPayment: (props) => <BaseSvgIcon iconPath={mdiCreditCardOutline} {...props} />,
  btnPaymentActions: (props) => <BaseSvgIcon iconPath={mdiCreditCardSettingsOutline} {...props} />,
  btnPeriod: (props) => <BaseSvgIcon iconPath={mdiCalendarRange} {...props} />,
  btnPing: (props) => <BaseSvgIcon iconPath={mdiSwapHorizontal} {...props} />,
  btnPlanning: (props) => <BaseSvgIcon iconPath={mdiCalendarText} {...props} />,
  btnPlus: (props) => <BaseSvgIcon iconPath={mdiPlusCircleOutline} {...props} />,
  btnPower: (props) => <BaseSvgIcon iconPath={mdiPower} {...props} />,
  btnPrevPage: (props) => <BaseSvgIcon iconPath={mdiChevronLeft} {...props} />,
  btnPriceGridDelete: (props) => <BaseSvgIcon iconPath={mdiClipboardRemoveOutline} {...props} />,
  btnPriceGrids: (props) => <BaseSvgIcon iconPath={mdiClipboardListOutline} {...props} />,
  btnReboot: (props) => <BaseSvgIcon iconPath={mdiPowerStandby} {...props} />,
  btnRefresh: (props) => <BaseSvgIcon iconPath={mdiRefresh} {...props} />,
  btnRemoveCarpark: (props) => <BaseSvgIcon iconPath={mdiDomainOff} {...props} />,
  btnReplace: (props) => <BaseSvgIcon iconPath={mdiContentDuplicate} {...props} />,
  btnReset: (props) => <BaseSvgIcon iconPath={mdiBackupRestore} {...props} />,
  btnResetAntipassback: (props) => <BaseSvgIcon iconPath={mdiRestore} {...props} />,
  btnSave: (props) => <BaseSvgIcon iconPath={mdiContentSave} {...props} />,
  btnSearch: (props) => <BaseSvgIcon iconPath={mdiMagnify} {...props} />,
  btnSelect: (props) => <BaseSvgIcon iconPath={mdiArrowRightCircleOutline} {...props} />,
  btnSelectCustomers: (props) => <BaseSvgIcon iconPath={mdiAccountMultiple} {...props} />,
  btnServiceFeeRule: (props) => <BaseSvgIcon iconPath={mdiCurrencyEur} {...props} />,
  btnSettings: (props) => <BaseSvgIcon iconPath={mdiCog} {...props} />,
  btnSimcard: (props) => <BaseSvgIcon iconPath={mdiSim} {...props} />,
  btnSlug: (props) => <BaseSvgIcon iconPath={mdiLink} {...props} />,
  btnStop: (props) => <BaseSvgIcon iconPath={mdiStop} {...props} />,
  btnSync: (props) => <BaseSvgIcon iconPath={mdiSync} {...props} />,
  btnTable: (props) => <BaseSvgIcon iconPath={mdiTable} {...props} />,
  btnTrigger: (props) => <BaseSvgIcon iconPath={mdiPlayCircleOutline} {...props} />,
  btnUpload: (props) => <BaseSvgIcon iconPath={mdiUpload} {...props} />,
  btnUserPhone: (props) => <BaseSvgIcon iconPath={mdiAccountBoxOutline} {...props} />,
  btnUsers: (props) => <BaseSvgIcon iconPath={mdiAccountMultiple} {...props} />,
  btnValidate: (props) => <BaseSvgIcon iconPath={mdiCheckCircle} {...props} />,
  btnValidatePayment: (props) => <BaseSvgIcon iconPath={mdiCreditCardCheck} {...props} />,
  btnWithdrawCustomer: (props) => <BaseSvgIcon iconPath={mdiAccountMinus} {...props} />,
  // Models / left menu
  account: (props) => <BaseSvgIcon iconPath={mdiLockOpenOutline} {...props} />,
  accountList: (props) => <BaseSvgIcon iconPath={mdiAccountGroupOutline} {...props} />,
  carpark: (props) => <BaseSvgIcon iconPath={mdiDomain} {...props} />,
  company: (props) => <BaseSvgIcon iconPath={mdiCityVariant} {...props} />,
  device: (props) => <BaseSvgIcon iconPath={mdiDeveloperBoard} {...props} />,
  deviceBatch: (props) => <BaseSvgIcon iconPath={mdiTextBoxMultipleOutline} {...props} />,
  deviceModel: (props) => <BaseSvgIcon iconPath={mdiHexagonMultipleOutline} {...props} />,
  deviceSlave: (props) => <BaseSvgIcon iconPath={mdiLinkBoxOutline} {...props} />,
  distribution: (props) => <BaseSvgIcon iconPath={mdiFileTableOutline} {...props} />,
  entity: (props) => <BaseSvgIcon iconPath={mdiDomain} {...props} />,
  hardware: (props) => <BaseSvgIcon iconPath={mdiCogBox} {...props} />,
  installation: (props) => <BaseSvgIcon iconPath={mdiHomeCityOutline} {...props} />,
  invoice: (props) => <BaseSvgIcon iconPath={mdiTextBoxMultipleOutline} {...props} />,
  partner: (props) => <BaseSvgIcon iconPath={mdiCardAccountDetailsStarOutline} {...props} />,
  production: (props) => <BaseSvgIcon iconPath={mdiCogOutline} {...props} />,
  profile: (props) => <BaseSvgIcon iconPath={mdiAccountGroupOutline} {...props} />,
  rollout: (props) => <BaseSvgIcon iconPath={mdiProgressClock} {...props} />,
  simcard: (props) => <BaseSvgIcon iconPath={mdiSim} {...props} />,
  updates: (props) => <BaseSvgIcon iconPath={mdiUpdate} {...props} />,
  user: (props) => <BaseSvgIcon iconPath={mdiAccountMultiple} {...props} />,
  workspace: (props) => <BaseSvgIcon iconPath={mdiWarehouse} {...props} />,
  // Tabs
  tabAccesses: (props) => <BaseSvgIcon iconPath={mdiTimetable} {...props} />,
  tabAsyncOperations: (props) => <BaseSvgIcon iconPath={mdiCogTransferOutline} {...props} />,
  tabConfig: (props) => <BaseSvgIcon iconPath={mdiCog} {...props} />,
  tabCustomers: (props) => <BaseSvgIcon iconPath={mdiAccountMultiple} {...props} />,
  tabDashboard: (props) => <BaseSvgIcon iconPath={mdiMonitorDashboard} {...props} />,
  tabDevice: (props) => <BaseSvgIcon iconPath={mdiDeveloperBoard} {...props} />,
  tabDevicebatch: (props) => <BaseSvgIcon iconPath={mdiTextBoxMultipleOutline} {...props} />,
  tabDistributions: (props) => <BaseSvgIcon iconPath={mdiFileTableOutline} {...props} />,
  tabInfo: (props) => <BaseSvgIcon iconPath={mdiInformationOutline} {...props} />,
  tabLogs: (props) => <BaseSvgIcon iconPath={mdiFileDocumentOutline} {...props} />,
  tabOperation: (props) => <BaseSvgIcon iconPath={mdiAccountCog} {...props} />,
  tabParkings: (props) => <BaseSvgIcon iconPath={mdiParking} {...props} />,
  tabPlannings: (props) => <BaseSvgIcon iconPath={mdiCalendarText} {...props} />,
  tabReports: (props) => <BaseSvgIcon iconPath={mdiChartLine} {...props} />,
  tabRollout: (props) => <BaseSvgIcon iconPath={mdiProgressClock} {...props} />,
  tabScenarios: (props) => <BaseSvgIcon iconPath={mdiAnimationPlayOutline} {...props} />,
  tabSimcard: (props) => <BaseSvgIcon iconPath={mdiSim} {...props} />,
  // Items
  itemAccessRight: (props) => <BaseSvgIcon iconPath={mdiKeyStar} {...props} />,
  itemAccessWay: (props) => <BaseSvgIcon iconPath={mdiLoginVariant} {...props} />,
  itemAccessWay2: (props) => <BaseSvgIcon iconPath={mdiKey} {...props} />,
  itemAddress: (props) => <BaseSvgIcon iconPath={mdiMapMarker} {...props} />,
  itemAddressOutline: (props) => <BaseSvgIcon iconPath={mdiMapMarkerOutline} {...props} />,
  itemAntipassback: (props) => <BaseSvgIcon iconPath={mdiAxisXArrowLock} {...props} />,
  itemBooking: (props) => <BaseSvgIcon iconPath={mdiCalendarCursor} {...props} />,
  itemCapacity: (props) => <BaseSvgIcon iconPath={mdiArrowExpandAll} {...props} />,
  itemCarInfo: (props) => <BaseSvgIcon iconPath={mdiCarInfo} {...props} />,
  itemCarsInfo: (props) => <BaseSvgIcon iconPath={mdiCarMultiple} {...props} />,
  itemComments: (props) => <BaseSvgIcon iconPath={mdiInformationOutline} {...props} />,
  itemConfig: (props) => <BaseSvgIcon iconPath={mdiCogOutline} {...props} />,
  itemContact: (props) => <BaseSvgIcon iconPath={mdiAccountBoxOutline} {...props} />,
  itemCustomer: (props) => <BaseSvgIcon iconPath={mdiAccount} {...props} />,
  itemDate: (props) => <BaseSvgIcon iconPath={mdiCalendarToday} {...props} />,
  itemDateBegin: (props) => <BaseSvgIcon iconPath={mdiCalendarStart} {...props} />,
  itemDateCreation: (props) => <BaseSvgIcon iconPath={mdiCalendarEdit} {...props} />,
  itemDateEnd: (props) => <BaseSvgIcon iconPath={mdiCalendarEnd} {...props} />,
  itemDesc: (props) => <BaseSvgIcon iconPath={mdiTextBox} {...props} />,
  itemDevice: (props) => <BaseSvgIcon iconPath={mdiDeveloperBoard} {...props} />,
  itemDiscount: (props) => <BaseSvgIcon iconPath={mdiSale} {...props} />,
  itemEmail: (props) => <BaseSvgIcon iconPath={mdiEmail} {...props} />,
  itemEmailOutline: (props) => <BaseSvgIcon iconPath={mdiEmailOutline} {...props} />,
  itemFile: (props) => <BaseSvgIcon iconPath={mdiFile} {...props} />,
  itemGroup: (props) => <BaseSvgIcon iconPath={mdiHexagonMultiple} {...props} />,
  itemHour: (props) => <BaseSvgIcon iconPath={mdiClockOutline} {...props} />,
  itemIdentifier: (props) => <BaseSvgIcon iconPath={mdiCardTextOutline} {...props} />,
  itemIpAddress: (props) => <BaseSvgIcon iconPath={mdiIpNetwork} {...props} />,
  itemInformation: (props) => <BaseSvgIcon iconPath={mdiInformationVariant} {...props} />,
  itemLastComDate: (props) => <BaseSvgIcon iconPath={mdiCalendarClock} {...props} />,
  itemLock: (props) => <BaseSvgIcon iconPath={mdiLock} {...props} />,
  itemLogin: (props) => <BaseSvgIcon iconPath={mdiLogin} {...props} />,
  itemMultiple2: (props) => <BaseSvgIcon iconPath={mdiNumeric2BoxMultipleOutline} {...props} />,
  itemMultiple3: (props) => <BaseSvgIcon iconPath={mdiNumeric3BoxMultipleOutline} {...props} />,
  itemMultiple4: (props) => <BaseSvgIcon iconPath={mdiNumeric4BoxMultipleOutline} {...props} />,
  itemMultiple5: (props) => <BaseSvgIcon iconPath={mdiNumeric5BoxMultipleOutline} {...props} />,
  itemMultiple6: (props) => <BaseSvgIcon iconPath={mdiNumeric6BoxMultipleOutline} {...props} />,
  itemMultiple7: (props) => <BaseSvgIcon iconPath={mdiNumeric7BoxMultipleOutline} {...props} />,
  itemMultiple8: (props) => <BaseSvgIcon iconPath={mdiNumeric8BoxMultipleOutline} {...props} />,
  itemMultiple9: (props) => <BaseSvgIcon iconPath={mdiNumeric9BoxMultipleOutline} {...props} />,
  itemMultiple9Plus: (props) => <BaseSvgIcon iconPath={mdiNumeric9PlusBoxMultipleOutline} {...props} />,
  itemMultipleAntipassbackStates: (props) => <BaseSvgIcon iconPath={mdiAxisArrow} {...props} />,
  itemMultipleArrow: (props) => <BaseSvgIcon iconPath={mdiSwapHorizontal} {...props} />,
  itemNetworkOperator: (props) => <BaseSvgIcon iconPath={mdiAntenna} {...props} />,
  itemNothing: (props) => <BaseSvgIcon iconPath={mdiCancel} {...props} />,
  itemOpenDoor: (props) => <BaseSvgIcon iconPath={mdiBoomGateUp} {...props} />,
  itemParking: (props) => <BaseSvgIcon iconPath={mdiParking} {...props} />,
  itemParkingCategory: (props) => <BaseSvgIcon iconPath={mdiShape} {...props} />,
  itemPeriod: (props) => <BaseSvgIcon iconPath={mdiCalendarRange} {...props} />,
  itemPhone: (props) => <BaseSvgIcon iconPath={mdiPhone} {...props} />,
  itemPhoneOutline: (props) => <BaseSvgIcon iconPath={mdiPhoneOutline} {...props} />,
  itemPlanning: (props) => <BaseSvgIcon iconPath={mdiCalendarText} {...props} />,
  itemReference: (props) => <BaseSvgIcon iconPath={mdiPound} {...props} />,
  itemRightNoRestrictions: (props) => <BaseSvgIcon iconPath={mdiCalendarCheck} {...props} />,
  itemRightRestrictions: (props) => <BaseSvgIcon iconPath={mdiCalendarBlankMultiple} {...props} />,
  itemScenario: (props) => <BaseSvgIcon iconPath={mdiAnimationPlayOutline} {...props} />,
  itemSimcard: (props) => <BaseSvgIcon iconPath={mdiSim} {...props} />,
  itemSuccessCond: (props) => <BaseSvgIcon iconPath={mdiCheckCircleOutline} {...props} />,
  itemTask: (props) => <BaseSvgIcon iconPath={mdiCalendarCheck} {...props} />,
  itemTime: (props) => <BaseSvgIcon iconPath={mdiClockOutline} {...props} />,
  itemType: (props) => <BaseSvgIcon iconPath={mdiFormatListBulletedType} {...props} />,
  itemUser: (props) => <BaseSvgIcon iconPath={mdiAccount} {...props} />,
  itemUserOutline: (props) => <BaseSvgIcon iconPath={mdiAccountOutline} {...props} />,
  itemUserPermission: (props) => <BaseSvgIcon iconPath={mdiKey} {...props} />,
  itemValid: (props) => <BaseSvgIcon iconPath={mdiCheck} {...props} />,
  itemVehicle: (props) => <BaseSvgIcon iconPath={mdiCar} {...props} />,
  itemBank: (props) => <BaseSvgIcon iconPath={mdiBank} {...props} />,
  itemInvoice: (props) => <BaseSvgIcon iconPath={mdiTextBoxMultipleOutline} {...props} />,
  itemVatNumber: (props) => <BaseSvgIcon iconPath={mdiBankTransfer} {...props} />,
  itemWhatsapp: (props) => <BaseSvgIcon iconPath={mdiWhatsapp} {...props} />,

  // Async status
  asyncStatusNotSynchronized: (props) => <BaseSvgIcon iconPath={mdiCloudAlert} {...props} />,
  asyncStatusPending: (props) => <BaseSvgIcon iconPath={mdiCloudSync} {...props} />,
  asyncStatusSuccess: (props) => <BaseSvgIcon iconPath={mdiCloudCheckOutline} {...props} />,
  asyncStatusSynchronized: (props) => <BaseSvgIcon iconPath={mdiCloudCheck} {...props} />,
  asyncStatusWarning: (props) => <BaseSvgIcon iconPath={mdiCloudAlert} {...props} />,
  // Async rollback status
  asyncRollbackStatusCommitted: (props) => <BaseSvgIcon iconPath={mdiCheckCircleOutline} {...props} />,
  asyncRollbackStatusPending: (props) => <BaseSvgIcon iconPath={mdiSync} {...props} />,
  asyncRollbackStatusRollbacked: (props) => <BaseSvgIcon iconPath={mdiBackupRestore} {...props} />,
  // Timeline
  tlEvent: (props) => <BaseSvgIcon iconPath={mdiStepForward} {...props} />,
  tlStart: (props) => <BaseSvgIcon iconPath={mdiArrowDown} {...props} />,
  // Device
  deviceEquStatusNok: (props) => <BaseSvgIcon iconPath={mdiHelpNetwork} {...props} />,
  deviceEquStatusOk: (props) => <BaseSvgIcon iconPath={mdiCheckNetwork} {...props} />,
  deviceOffline: (props) => <BaseSvgIcon iconPath={mdiCloudOffOutline} {...props} />,
  deviceOnline: (props) => <BaseSvgIcon iconPath={mdiCloudCheck} {...props} />,
  // Device relays
  dRelayState0: (props) => <BaseSvgIcon iconPath={mdiElectricSwitch} {...props} />,
  dRelayState1: (props) => <BaseSvgIcon iconPath={mdiElectricSwitchClosed} {...props} />,
  dRelayStateBs: (props) => <BaseSvgIcon iconPath={mdiShuffle} {...props} />,
  dRelayStateNone: (props) => <BaseSvgIcon iconPath={mdiCancel} {...props} />,
  // Device inputs
  dInputState0: (props) => <BaseSvgIcon iconPath={mdiNumeric0Circle} {...props} />,
  dInputState0to1: (props) => <BaseSvgIcon iconPath={mdiTrendingUp} {...props} />,
  dInputState1: (props) => <BaseSvgIcon iconPath={mdiNumeric1Circle} {...props} />,
  dInputState1to0: (props) => <BaseSvgIcon iconPath={mdiTrendingDown} {...props} />,
  dInputStateNone: (props) => <BaseSvgIcon iconPath={mdiCancel} {...props} />,
  // Signal strength
  sigSth0: (props) => <BaseSvgIcon iconPath={mdiNetworkStrengthOffOutline} {...props} />,
  sigSth1: (props) => <BaseSvgIcon iconPath={mdiNetworkStrength1Alert} {...props} />,
  sigSth2: (props) => <BaseSvgIcon iconPath={mdiNetworkStrength1} {...props} />,
  sigSth3: (props) => <BaseSvgIcon iconPath={mdiNetworkStrength2} {...props} />,
  sigSth4: (props) => <BaseSvgIcon iconPath={mdiNetworkStrength3} {...props} />,
  sigSth5: (props) => <BaseSvgIcon iconPath={mdiNetworkStrength4} {...props} />,
  sigSthUnknown: (props) => <BaseSvgIcon iconPath={mdiNetworkStrengthOutline} {...props} />,
  // Signal techno
  sigTech2g: (props) => <BaseSvgIcon iconPath={mdiSignal2g} {...props} />,
  sigTech3g: (props) => <BaseSvgIcon iconPath={mdiSignal3g} {...props} />,
  sigTech4g: (props) => <BaseSvgIcon iconPath={mdiSignal4g} {...props} />,
  // Device trigger
  dtrApi: (props) => <BaseSvgIcon iconPath={mdiCodeTags} {...props} />,
  dtrGsm: (props) => <BaseSvgIcon iconPath={mdiPhone} {...props} />,
  dtrUnknown: (props) => <BaseSvgIcon iconPath={mdiHelpNetwork} {...props} />,
  // Device logs
  dLogOriginDevice: (props) => <BaseSvgIcon iconPath={mdiDeveloperBoard} {...props} />,
  dLogOriginServer: (props) => <BaseSvgIcon iconPath={mdiServerNetwork} {...props} />,
  dLogTagConn: (props) => <BaseSvgIcon iconPath={mdiNetworkOutline} {...props} />,
  dLogTagIdle: (props) => <BaseSvgIcon iconPath={mdiPlaySpeed} {...props} />,
  dLogTagPower: (props) => <BaseSvgIcon iconPath={mdiPowerStandby} {...props} />,
  dLogTagSystem: (props) => <BaseSvgIcon iconPath={mdiCogOutline} {...props} />,
  // Device SMS
  dSmsTypeOperatorsConfig: (props) => <BaseSvgIcon iconPath={mdiCogTransferOutline} {...props} />,
  dSmsTypeReboot: (props) => <BaseSvgIcon iconPath={mdiPowerStandby} {...props} />,
  dSmsTypeReset: (props) => <BaseSvgIcon iconPath={mdiBackupRestore} {...props} />,
  dSmsTypeStatus: (props) => <BaseSvgIcon iconPath={mdiMessageTextOutline} {...props} />,
  dSmsTypeSync: (props) => <BaseSvgIcon iconPath={mdiSync} {...props} />,
  // Equipments
  equKeypad: (props) => <BaseSvgIcon iconPath={mdiDialpad} {...props} />,
  equLpr: (props) => <BaseSvgIcon iconPath={mdiCctv} {...props} />,
  equRfid: (props) => <BaseSvgIcon iconPath={mdiCastConnected} {...props} />,
  equUhf: (props) => <BaseSvgIcon iconPath={mdiCast} {...props} />,
  // Sources
  stypeIndLoop: (props) => <BaseSvgIcon iconPath={mdiSelectAll} {...props} />,
  stypePushBut: (props) => <BaseSvgIcon iconPath={mdiRadioboxMarked} {...props} />,
  stypeSensor: (props) => <BaseSvgIcon iconPath={mdiMemory} {...props} />,
  // Doors
  dusagePed: (props) => <BaseSvgIcon iconPath={mdiWalk} {...props} />,
  dusageVeh: (props) => <BaseSvgIcon iconPath={mdiCarSide} {...props} />,
  // Scenarios
  scPriority: (props) => <BaseSvgIcon iconPath={mdiRecord} {...props} />,
  scTrigTypeInput: (props) => <BaseSvgIcon iconPath={mdiLogin} {...props} />,
  scTrigTypeNa: (props) => <BaseSvgIcon iconPath={mdiCancel} {...props} />,
  scTrigTypeOutput: (props) => <BaseSvgIcon iconPath={mdiLogout} {...props} />,
  // Customers
  cAwTypeKCode: (props) => <BaseSvgIcon iconPath={mdiDialpad} {...props} />,
  cAwTypeLPlate: (props) => <BaseSvgIcon iconPath={mdiCar} {...props} />,
  cAwTypePhone: (props) => <BaseSvgIcon iconPath={mdiPhone} {...props} />,
  customerOpBookingUsageB2bSubscription: (props) => <BaseSvgIcon iconPath={mdiDomain} {...props} />,
  customerOpBookingUsagePackage: (props) => <BaseSvgIcon iconPath={mdiCalendarCursor} {...props} />,
  customerOpBookingUsageSubscription: (props) => <BaseSvgIcon iconPath={mdiCalendarRefresh} {...props} />,
  // Installation logs
  iLogTypeAccess: (props) => <BaseSvgIcon iconPath={mdiAccount} {...props} />,
  iLogTypeApi: (props) => <BaseSvgIcon iconPath={mdiMonitorCellphoneStar} {...props} />,
  iLogTypeApiRight: (props) => <BaseSvgIcon iconPath={mdiMonitorCellphoneStar} {...props} />,
  iLogTypeOnDemand: (props) => <BaseSvgIcon iconPath={mdiLoginVariant} {...props} />,
  iLogTypeTask: (props) => <BaseSvgIcon iconPath={mdiCalendarClock} {...props} />,
  iLogTypeTrigger: (props) => <BaseSvgIcon iconPath={mdiAnimationPlayOutline} {...props} />,
  // Antipassbacks
  antipassbackEntrance: (props) => <BaseSvgIcon iconPath={mdiLogin} {...props} />,
  antipassbackExit: (props) => <BaseSvgIcon iconPath={mdiLogout} {...props} />,
  // Simcard status
  simcardStatusActivationInProgress: (props) => <BaseSvgIcon iconPath={mdiProgressCheck} {...props} />,
  simcardStatusActive: (props) => <BaseSvgIcon iconPath={mdiCheckCircle} {...props} />,
  simcardStatusInactive: (props) => <BaseSvgIcon iconPath={mdiMinusCircleOutline} {...props} />,
  simcardStatusSuspended: (props) => <BaseSvgIcon iconPath={mdiPauseCircleOutline} {...props} />,
  simcardStatusUnknown: (props) => <BaseSvgIcon iconPath={mdiHelpCircleOutline} {...props} />,
  // on-demand
  onDemandSelfCheckoutDefinitiveExit: (props) => <BaseSvgIcon iconPath={mdiLogoutVariant} {...props} />,
  onDemandSelfCheckoutDropOffExit: (props) => <BaseSvgIcon iconPath={mdiClockEnd} {...props} />,
  onDemandSelfCheckoutTemporaryExit: (props) => <BaseSvgIcon iconPath={mdiUpdate} {...props} />,
  onDemandSelfCheckoutNotDone: (props) => <BaseSvgIcon iconPath={mdiCalendarQuestion} {...props} />,
  // Parking status
  parkingStatusCreated: (props) => <BaseSvgIcon iconPath={mdiCalendarCheckOutline} {...props} />,
  parkingStatusInProgress: (props) => <BaseSvgIcon iconPath={mdiCalendarBlankOutline} {...props} />,
  parkingStatusInProgressWithPlanning: (props) => <BaseSvgIcon iconPath={mdiCalendarTextOutline} {...props} />,
  parkingStatusStarted: (props) => <BaseSvgIcon iconPath={mdiCalendarBadgeOutline} {...props} />,
  parkingStatusStartedWithPlanning: (props) => <BaseSvgIcon iconPath={mdiCalendarText} {...props} />,
  parkingStatusFinished: (props) => <BaseSvgIcon iconPath={mdiCalendarEndOutline} {...props} />,
  parkingStatusInOverstay: (props) => <BaseSvgIcon iconPath={mdiCalendarAlertOutline} {...props} />,
  parkingStatusCancelled: (props) => <BaseSvgIcon iconPath={mdiCalendarRemoveOutline} {...props} />,
  // Parking price types
  parkingPriceTypeFree: (props) => <BaseSvgIcon iconPath={mdiCurrencyEurOff} {...props} />,
  parkingPriceTypePaying: (props) => <BaseSvgIcon iconPath={mdiCurrencyEur} {...props} />,
  // payment statuses
  paymentStatusCancelled: (props) => <BaseSvgIcon iconPath={mdiCancel} {...props} />,
  paymentStatusError: (props) => <BaseSvgIcon iconPath={mdiAlertCircleOutline} {...props} />,
  paymentStatusInProgress: (props) => <BaseSvgIcon iconPath={mdiProgressClock} {...props} />,
  paymentStatusPaid: (props) => <BaseSvgIcon iconPath={mdiCheckCircleOutline} {...props} />,
  paymentStatusRefunded: (props) => <BaseSvgIcon iconPath={mdiCreditCardRefundOutline} {...props} />,
  paymentStatusRequired: (props) => <BaseSvgIcon iconPath={mdiAlertCircleOutline} {...props} />,
  paymentStatusSucceeded: (props) => <BaseSvgIcon iconPath={mdiCheckCircleOutline} {...props} />,
  // Account
  accountStatusActive: (props) => <BaseSvgIcon iconPath={mdiCheckCircle} {...props} />,
  accountStatusInactive: (props) => <BaseSvgIcon iconPath={mdiMinusCircleOutline} {...props} />,
  accountStatusPending: (props) => <BaseSvgIcon iconPath={mdiTimerSand} {...props} />,
  accountStatusMixed: (props) => <BaseSvgIcon iconPath={mdiHexagonMultiple} {...props} />,
  // Accesses
  accessTypeAccess: (props) => <BaseSvgIcon iconPath={mdiAccount} {...props} />,
  accessTypeOnDemand: (props) => <BaseSvgIcon iconPath={mdiLoginVariant} {...props} />,
  accessTypeTriggerDoor: (props) => <BaseSvgIcon iconPath={mdiMonitorCellphoneStar} {...props} />,
  accessUsageInput: (props) => <BaseSvgIcon iconPath={mdiLocationEnter} {...props} />,
  accessUsageOutput: (props) => <BaseSvgIcon iconPath={mdiLocationExit} {...props} />,
  accessUsageNa: (props) => <BaseSvgIcon iconPath={mdiCancel} {...props} />,
  // Carpark synchronization step
  carparkStepNotSynchronized: (props) => <BaseSvgIcon iconPath={mdiAlertOutline} {...props} />,
  carparkStepSynchronized: (props) => <BaseSvgIcon iconPath={mdiCheckCircleOutline} {...props} />,
  // Files
  fileUploaded: (props) => <BaseSvgIcon iconPath={mdiFileCheck} {...props} />,
  fileUploading: (props) => <BaseSvgIcon iconPath={mdiFileUpload} {...props} />,
  // Navigation
  navFirstPage: (props) => <BaseSvgIcon iconPath={mdiPageFirst} {...props} />,
  navLastPage: (props) => <BaseSvgIcon iconPath={mdiPageLast} {...props} />,
  navNextPage: (props) => <BaseSvgIcon iconPath={mdiChevronRight} {...props} />,
  navPrevPage: (props) => <BaseSvgIcon iconPath={mdiChevronLeft} {...props} />,
  // Notifications
  notificationInfo: (props) => <BaseSvgIcon iconPath={mdiInformationOutline} {...props} />,
  notificationSuccess: (props) => <BaseSvgIcon iconPath={mdiCheckboxMarkedCircleOutline} {...props} />,
  notificationWarning: (props) => <BaseSvgIcon iconPath={mdiAlertOutline} {...props} />,
  notificationError: (props) => <BaseSvgIcon iconPath={mdiAlertCircleOutline} {...props} />,
  // Products
  productOpac: (props) => <BaseSvgIcon iconPath={mdiDeveloperBoard} {...props} />,
  productParking: (props) => <BaseSvgIcon iconPath={mdiParking} {...props} />,
  // Map
  mapMarker: (props) => <BaseSvgIcon iconPath={mdiMapMarker} {...props} />,
  // Occupancy states
  occupancyStateInside: (props) => <BaseSvgIcon iconPath={mdiLocationEnter} {...props} />,
  occupancyStateOutside: (props) => <BaseSvgIcon iconPath={mdiLocationExit} {...props} />,
  occupancyStateUnknown: (props) => <BaseSvgIcon iconPath={mdiHelpCircleOutline} {...props} />,
  // User
  userRollbackStrategyAlwaysCommit: (props) => <BaseSvgIcon iconPath={mdiDatabaseCheckOutline} {...props} />,
  userRollbackStrategyRollback: (props) => <BaseSvgIcon iconPath={mdiBackupRestore} {...props} />,
  // Misc
  cancelled: (props) => <BaseSvgIcon iconPath={mdiCancel} {...props} />,
  check: (props) => <BaseSvgIcon iconPath={mdiCheck} {...props} />,
  checkActive: (props) => <BaseSvgIcon iconPath={mdiCheckboxMarkedOutline} {...props} />,
  checkInactive: (props) => <BaseSvgIcon iconPath={mdiCheckboxBlankOutline} {...props} />,
  checkIntermediate: (props) => <BaseSvgIcon iconPath={mdiCheckboxIntermediate} {...props} />,
  debug: (props) => <BaseSvgIcon iconPath={mdiBug} {...props} />,
  disabled: (props) => <BaseSvgIcon iconPath={mdiCancel} {...props} />,
  error: (props) => <BaseSvgIcon iconPath={mdiAlertCircle} {...props} />,
  filter: (props) => <BaseSvgIcon iconPath={mdiFilter} {...props} />,
  forbid: (props) => <BaseSvgIcon iconPath={mdiMinusCircle} {...props} />,
  info: (props) => <BaseSvgIcon iconPath={mdiInformation} {...props} />,
  infoAlt: (props) => <BaseSvgIcon iconPath={mdiInformationOutline} {...props} />,
  pending: (props) => <BaseSvgIcon iconPath={mdiTimerSand} {...props} />,
  progressUp: (props) => <BaseSvgIcon iconPath={mdiProgressUpload} {...props} />,
  radioChecked: (props) => <BaseSvgIcon iconPath={mdiRadioboxMarked} {...props} />,
  radioUnchecked: (props) => <BaseSvgIcon iconPath={mdiRadioboxBlank} {...props} />,
  stopped: (props) => <BaseSvgIcon iconPath={mdiStopCircle} {...props} />,
  subItem: (props) => <BaseSvgIcon iconPath={mdiSubdirectoryArrowRight} {...props} />,
  success: (props) => <BaseSvgIcon iconPath={mdiCheckCircle} {...props} />,
  timezone: (props) => <BaseSvgIcon iconPath={mdiWebClock} {...props} />,
  thus: (props) => <BaseSvgIcon iconPath={mdiArrowRightBold} {...props} />,
  unknown: (props) => <BaseSvgIcon iconPath={mdiHelpCircleOutline} {...props} />,
  warning: (props) => <BaseSvgIcon iconPath={mdiAlert} {...props} />,
  warningAlt: (props) => <BaseSvgIcon iconPath={mdiAlertOutline} {...props} />,
  wsClosed: (props) => <BaseSvgIcon iconPath={mdiLinkOff} {...props} />,
  wsOpen: (props) => <BaseSvgIcon iconPath={mdiLink} {...props} />,
};
/* eslint-enable react/display-name */

export default SvgIcons;



// WEBPACK FOOTER //
// ./components/core/SvgIcons.js